// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f6a21324","732":"bf3d8b6b","977":"a9859356"}[chunkId] + ".chunk.js";
};